import React from "react";
import AlternativeOfferBanner from "./AlternativeOfferBanner";
import ExitIntentPopup from "./ExitIntentPopup";

/**
 * AlternativeOfferSection
 * Convenience wrapper that renders BOTH the AlternativeOfferBanner
 * (visual section above the footer) AND the ExitIntentPopup using
 * the same offer copy/destination. Drop-in usage on any page:
 *
 *   <AlternativeOfferSection
 *     headline="Build me a funnel instead"
 *     subheadline="Fully managed funnels that turn attention into revenue."
 *     ctaText="Explore Funnels"
 *     ctaTo="/funnels"
 *   />
 *   <Footer />
 */
export default function AlternativeOfferSection({
  // Banner content
  bannerEyebrow = "Not the right fit?",
  // Popup content
  popupEyebrow = "Wait — before you go",
  // Shared
  headline,
  subheadline,
  ctaText = "Take Me There",
  ctaTo,
  ctaHref,
  // Allow per-page customization of the popup body if it should differ
  popupHeadline,
  popupSubheadline,
  popupCtaText,
  popupCtaTo,      // optional override — popup can go somewhere different from banner
  popupCtaHref,    // optional override (anchor link, e.g. "#reserve")
  // Urgency timer (off by default — flip on for lead-magnet / free-ebook pages)
  popupShowUrgencyTimer = false,
  popupUrgencyTimerKey,
  popupUrgencyTimerLabel,
  // Analytics
  bannerEventName,
  popupEventPrefix = "exit_intent",
}) {
  return (
    <>
      <AlternativeOfferBanner
        eyebrow={bannerEyebrow}
        headline={headline}
        subheadline={subheadline}
        ctaText={ctaText}
        ctaTo={ctaTo}
        ctaHref={ctaHref}
        eventName={bannerEventName}
      />
      <ExitIntentPopup
        eyebrow={popupEyebrow}
        headline={popupHeadline || headline}
        subheadline={popupSubheadline || subheadline}
        ctaText={popupCtaText || ctaText}
        ctaTo={popupCtaTo !== undefined ? popupCtaTo : ctaTo}
        ctaHref={popupCtaHref !== undefined ? popupCtaHref : ctaHref}
        eventPrefix={popupEventPrefix}
        showUrgencyTimer={popupShowUrgencyTimer}
        urgencyTimerKey={popupUrgencyTimerKey}
        urgencyTimerLabel={popupUrgencyTimerLabel}
      />
    </>
  );
}
